<template>
    <div class="progress-bar" :style="'width:' + progress + '%'"
         :class="getCssClass()"
    >
        <span>{{ progress }}%</span>
    </div>
</template>

<script>

export default
{
    components: {},
    props: {
        config: {
            type: Object,
            default: function() {
                return {
                    queueName: '',
                    queueParams: {},
                    emitEvents: [],
                }
            }
        },
        eventBus: {
            type: Object,
        },
        row: {
            type: Object,
        },
        eventSourceService: {
            type: Object,
        },
        parent: {
            type: Object,
        },
        eventManager: {
            type: Object,
        }
    },
    data() {
        return {
            progress: 0,
            queueName: null,
            queueParams: {},
            subscribeQueue: false,
        };
    },
    computed: {
    },
    mounted() {
        this.init();
        this.setProgress(this.row.progress);

        if (100 > this.progress && 'pending' === this.row.status) {
            this.mountEvents();
        }
    },
    beforeDestroy() {
        this.unmountEvents();
    },
    methods: {
        getCssClass() {
            return {
                'progress-bar-red': this.progress < 20,
                'progress-bar-orange': this.progress >= 20 && this.progress < 50,
                'progress-bar-yellow': this.progress >= 50 && this.progress < 70,
                'progress-bar-almost-done': this.progress >= 70 && this.progress < 100,
                'progress-bar-done': this.progress === 100
            };
        },
        init() {
            this.queueName = this.config.queueName;
            this.queueParams = this.config.queueParams;
        },
        mountEvents() {
            this.subscribeQueue = true;
            this.eventSourceService.addQueue(this.queueName, this.queueParams);
            this.eventBus.$on(`EventSourceService:${this.queueName}:onMessage`, this.onmessage);
        },
        unmountEvents() {
            if (!this.subscribeQueue) {
                return;
            }

            this.eventSourceService.removeQueue(this.queueName);
            this.eventBus.$off(`EventSourceService:${this.queueName}:onMessage`);
        },
        onmessage(data) {
            let item = data.filter(v => v.id === this.row.id);

            if (0 === item.length) {
                return;
            }

            this.setProgress(item[0].progress);

            if (100 === this.progress) {
                this.unmountEvents();
                this.eventManager.emitEvents(this.config.emitEvents['progressDone'] || [], this.row);
            }
        },
        setProgress(progress) {
            this.progress = progress;
        }
    }
}

</script>

<style lang="sass">
    .progress-bar-red {
        background-color: #dc5f69;
    }
    .progress-bar-yellow {
        background: linear-gradient(to right, #f5e52a, white);
    }
    .progress-bar-orange {
        background: linear-gradient(to left, orange, white);
    }
    .progress-bar-almost-done {
        background: linear-gradient(to right, #78ec62, white);
    }
    .progress-bar-done {
        background-color: #4baf4d;
    }
    .progress-bar {
        display: block;
        color: black;
        border-radius: 15px;
        padding: 5px;
        text-align: center;
        box-shadow: 0 6px 5px 0 #0000003f;
    }
</style>


// WEBPACK FOOTER //
// ProgressBarComponent.vue?54789dd2